<template>
  <div class="upload">
    <Uploader
      :accept="!!isOa ? 'all' : 'image'"
      :after-read="imageHandler"
      :max-count="1"
      :before-read="beforeRead"
      :disabled="isDisabled"
      @delete="onDelete"
    >
      <!--  more flexible body content to reuse this component.    -->
      <slot>
        <div class="img" :style="`align-items:${isOa ? 'flex-end' : 'center'}`" v-if="value.length > 0 && !loading">
          <img v-if="!isOa" :src="value[0].url" alt />

          <div v-else class="file-name">
            <Icon class="description-icon" name="description" color="#BBBDBF" />
            <span class="file-name-text">{{ value[0].name }}</span>
          </div>
        </div>
        <div class="content" v-else>
          <Icon name="plus" color="#BBBDBF" v-if="!loading" />
          <Loading v-else />
        </div>
      </slot>
    </Uploader>
    <Icon
      name="cross"
      @click="remove"
      class="cross-icon"
      color="#fff"
      v-if="isDelete && value.length > 0 && !loading"
    />
  </div>
</template>

<script>
import { Uploader, Icon, Notify, Loading } from 'vant';
import api from '@/services/api';

// import * as EXIF from 'exif-js';
import avatar from '@/assets/img/example.png';
export default {
  props: ['value', 'onFail', 'isDelete', 'isOa', 'name'],
  components: { Uploader, Icon, Loading },
  data() {
    return {
      avatar,
      loading: false,
      show: false,
      code: null,
    };
  },
  watch: {
    name(cur, old) {
      if (!cur || (!!old && old !== cur)) {
        this.$emit('input', []);
      }
    },
  },
  computed: {
    isDisabled() {
      return !this.name && !!this.isOa;
    },
  },
  methods: {
    onDelete() {
      this.$emit('input', []);
    },
    remove() {
      this.$emit('input', []);
    },
    beforeRead(file) {
      if (!this.isOa && file.type !== 'image/jpeg' && file.type !== 'image/png') {
        Notify({
          type: 'warning',
          message: this.$t('visitor.apply.photo.type.tips'),
        });
        return false;
      }

      return true;
    },
    transFileName(val) {
      if (val) {
        const arr = val.split('.');
        return arr.length ? arr[1] : '';
      }
    },
    async afterRead(file) {
      const formData = new FormData();
      const tempFile = file;
      const type = file.type;
      const size = file.size;
      const newName = encodeURIComponent(file.name);
      const newFile = new File([tempFile], newName, { type, size });

      formData.append('file', newFile);
      // this.isOa && formData.append('name', this.name);
      // console.log('formData',formData);s
      this.loading = true;
      const [status, res] = await (this.isOa
        ? api.uploadOaFile({ name: this.name, formData })
        : api.uploadFile(formData));
      if (status) {
        const value = [
          {
            id: res.data.fileId,
            url: res.data.fileUrl,
            bizId: this.isOa ? res.data.bizId : undefined,
            name: this.transFileName(res.data.fileId),
          },
        ];

        this.$emit('input', value);
      } else {
        // instead of showing default Dialog, we may want to handle failed upload outside.
        if (this.onFail) {
          this.onFail(res);
        } else {
          // disable Popover
          // this.code = res.respCode;
          // this.show = true;
        }
      }
      this.loading = false;
    },

    imageHandler(fileData) {
      const file = fileData.file;
      const _this = this;
      // EXIF.getData(file, function() {
      //   const Orientation = EXIF.getTag(this, 'Orientation');
      //   if (Orientation && Orientation != 1) {
      //     _this.imageOrientation(Orientation, file);
      //   } else {
      _this.afterRead(file);
      //   }
      // });
    },

    imageOrientation(Orientation, file) {
      const _this = this;
      const reader = new FileReader();
      const image = new Image();
      reader.readAsDataURL(file);

      reader.onload = function (ev) {
        image.src = ev.target.result;
        image.onload = function () {
          const imgWidth = this.width;
          const imgHeight = this.height;
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = imgWidth;
          canvas.height = imgHeight;
          if (Orientation && Orientation != 1) {
            switch (Orientation) {
              case 6: // 旋转90度
                canvas.width = imgHeight;
                canvas.height = imgWidth;
                ctx.rotate(Math.PI / 2);
                ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
                break;
              case 3: // 旋转180度
                ctx.rotate(Math.PI);
                ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
                break;
              case 8: // 旋转-90度
                canvas.width = imgHeight;
                canvas.height = imgWidth;
                ctx.rotate((3 * Math.PI) / 2);
                ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
                break;
            }
          } else {
            ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
          }

          canvas.toBlob(
            blob => {
              if (!blob) {
                Notify({
                  type: 'warning',
                  message: this.$t('visitor.apply.photo.type.tips'),
                });
                return;
              } else {
                _this.afterRead(blob);
              }
            },
            'image/jpeg',
            1
          );
        };
      };
    },
  },
};
</script>

<style lang="less">
.upload {
  margin: 20px 0;
  position: relative;
  background: rgba(0, 0, 0, 0.08);

  .cross-icon {
    font-size: 24px;
    position: absolute;
    right: -10px;
    top: -10px;
    background-color: red;
    border-radius: 50%;
    padding: 2px;
  }

  .content {
    background-color: #f0f2f5;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
  }

  .img {
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    .file-name {
      display: flex;
      flex-direction: column;
      .file-name-text {
        font-size: 18px;
        color: #5d6067;
        padding-bottom: 8px;
      }
    }
    .description-icon {
      font-size: 50px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.van-uploader__preview {
  margin: 0 !important;
}
.van-uploader {
  display: block;
}
.van-uploader__preview-image {
  width: 120px;
  height: 120px;
}
.van-popup.van-popup--center {
  border-radius: 10px;
}
.popContent {
  width: 600px;
  padding: 40px;
  min-height: 300px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .popTitle {
    font-size: 36px;
    color: #3d424d;
    font-weight: bold;
    margin-bottom: 50px;
  }

  img {
    width: 160px;
  }

  .popTips {
    font-size: 24px;
    color: #7e838c;
    margin: 10px 0 50px 0;
  }

  .popList {
    font-size: 28px;
    color: #5d6067;
    position: relative;
    margin-bottom: 10px;

    &::before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #00ccbf;
      left: -20px;
      top: 16px;
    }
  }
  .popConfirm {
    margin-top: 60px;
    width: 320px;
    height: 78px;
    font-size: 32px;
    color: #ffffff;
    background: #00ccbf;
    border-radius: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
